module.exports = __webpack_public_path__ + "img/bg_标题@2x.3dc181ee.png";